
<script>

  import func from "../../libs/functions.js";

  import {
    mapGetters,
    mapActions
  } from "vuex";


   import iziToast from 'izitoast'
   import 'izitoast/dist/css/iziToast.min.css';
  
  import _ from "lodash";

  import _system from '../../libs/system';

export default {
   name: "CreateTicket",
   data() {
      return {
         selectedPage:{},
         ticket: {},
         selectedTags: [],
         loading: {
            sendTicket: false
         },
         tag: ''
      }
   },
   computed: {
   ...mapGetters('workspaces', ['workspaces', 'currentWorkspace']),
   ...mapGetters('session', ['isLoggedIn', 'getUser']),
   ...mapGetters('accounts', ['accounts', 'accountsByName', 'workspaceAccountsById']),
   ...mapGetters('networks', ['networks', 'networksByName', 'networksById']),
   ...mapGetters('tags', ['tags', 'tagsByName', 'tagsByTypeName', 'tagsById']),
   ...mapGetters('messages', ['messages']),
      getFilteredPages(){
         if(this.getUser.email == 'musteri-iletisim@tr.estee.com'){
            return this.workspaceAccountsById
         }else{
            //return _.filter(this.accounts, { platform: this.networksByName['Instagram']._id })
            return this.accounts
         }
      }
   },
   methods: {
   ...mapActions("htmlModals", ["setTicketModal"]),
   ...mapActions('tags', ['setTags', 'setPushTag']),
   ...mapActions('workspaces', ['setWorkspaces', 'pushWorkspace', 'setCurrentWorkspace']),
   ...mapActions('workspaceusers', ['setWorkspaceusers']),
   ...mapActions("loading", ["setLoadingApp", "setLoadingAppReRender"]),   
      createTicket (){

        this.loading.sendTicket = true;

        if(!this.ticket.name.length || !this.selectedPage._id || !this.ticket.text.length){
          return alert('Name, Channel or Ticket text cannot be empty!');
        }
        
        let payload = {
            body: {
               "id" : (Date.now() + Math.random()).toString(),
               "createdAt" : +new Date(),
               "from" : {
                  "name" : this.ticket.name,
                  "phone" : this.ticket.phone,
                  "email" : this.ticket.email
            },
               "page" : this.selectedPage._id,
               "platform" : this.selectedPage.platform,
               "text" : this.ticket.text,
               "status" : "5c1ba8fb8db61a71373b339c",
               "is" : {
                  "conversationRoot" : true,
                  "directMessage": (this.selectedPage.platform == '5c0bcfb335563f46ca2921cb') ? true : false //If it's instagram!
               },
               "tags" : [ 
                  "5d9b2fa3dc7fa06db0cf7847",
                  "5eb7304806846b3b928e05d9"
               ],
               "notes" : []
            }
        }

        if(this.selectedTags.length){
           payload.body.tags = payload.body.tags.concat(this.selectedTags);
        }
        
        _system.services.messages.create(payload, (err, newTicket) => {
           if(err) return alert(err.message);
           this.messages.unshift(newTicket);
           this.loading.sendTicket = false;
            this.setTicketModal(false)
        });
       
      }
   },
   mounted(){

      $('.selectTag').dropdown({
         transition: 'fade',
         onChange: (value, text, $choice) => {
            this.selectedTags = value
         }
      });
   }
}

</script>

<template>


<div class="modalWrapper">
<div  @click="setCreateTag(false)" class="modal"> </div>
   <div class="ui grid">
      <div style="margin-top: 1rem;" class="ten wide column centered">
            <div style="padding: 0; z-index:9999999;" class="ui basic segment right aligned">
               <a style="background: rgba(0,0,0,0.6);" @click="setTicketModal(false)" class="ui black mini button">Close [ESC]</a>
            </div>
            <div style="z-index:9999999;" class="ui segment shadow">
      <div class="ui form">
        <div class="field">
          <label>Channels</label>
          <select v-model="selectedPage">
            <option disabled value="">Select a channel</option>
            <option v-for="page in getFilteredPages" :key="page._id" v-bind:value="page">{{page.name}} - {{networksById[page.platform].name}}</option>
          </select>
        </div>
        <label>Tags</label>
        <div class="field">
           <select name="skills" multiple="" class="ui fluid search selection dropdown selectTag">
               <option value="">Select Tag (Optional)</option>
               <option v-for="tag in tagsByTypeName['DefaultMessageTag']" :key="tag._id" :value="tag._id">{{tag.name}}</option>
               <option v-for="tag in currentWorkspace.userTags" :key="tag._id" :value="tag._id">{{tag.name}}</option>
            </select>
        </div>
        <div class="field">
          <label>Customer Name</label>
          <input v-model="ticket.name" type="text">
        </div>
        <div class="field">
          <label>Customer Phone - (+90) ülke kodunu lütfen en başa ekleyiniz örn: +905319687338</label>
          <input type="text" v-model="ticket.phone" >
        </div>
        <div class="field">
          <label>Customer Email</label>
          <input type="text" v-model="ticket.email" >
        </div>
        <div class="field">
          <label>Ticket Description</label>
          <textarea v-model="ticket.text" rows="4"></textarea>
        </div>
        <div class="field">
          <a @click="createTicket()" href="#" :class="(loading.sendTicket) ? 'loading':''" class="ui fluid blue button">Create New Ticket</a>
        </div>
      </div>
            </div>
      </div>
   </div>
</div>


</template>


<style scoped>
.modalWrapper {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   z-index: 999999; 
   overflow: hidden;
}
.modal {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   background: rgba(15, 17, 26, 0.35) none repeat scroll 0% 0%; 
   z-index: 999999; 
   overflow: hidden;
}

.shadow{
   box-shadow: 0px 0px 44px rgba(99, 99, 99, 0.85);
   border: none;
}
</style>





// WEBPACK FOOTER //
// src/components/dashboard/CreateTicket.vue